import { SxProps, Theme } from '@mui/material';

export const TOP_BAR_HEIGHT = '64px';
export const TOP_BAR_MARGIN = '0px';

export const TopBarStyles: SxProps<Theme> = {
  alignItems: 'center',
  backgroundColor: 'primary.white',
  color: 'primary.black',
  display: 'flex',
  height: TOP_BAR_HEIGHT,
  justifyContent: 'space-between',
  mb: TOP_BAR_MARGIN,
  position: 'sticky',
  px: 5,
  top: 0,
  width: '100%',
  zIndex: 500,
};

export const TopBarItemsStyles: SxProps<Theme> = {
  alignItems: 'center',
  justifyContent: 'space-between',
};
